<template>
  <a-form-model
    style="background: #ffffff;min-height:900px;padding-top: 20px;"
    ref="ruleForm"
    :model="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <a-form-model-item label="所属地区">
      <a-cascader :options="optionAreas"
                  v-model="areaIds"
                  :showSearch="showSearch"
                  @change="areaChange"
                  placeholder="请选择"
                  expandTrigger="hover"/>
    </a-form-model-item>
    <a-form-model-item ref="name" label="姓名" prop="name">
      <a-input
        placeholder="请输入姓名"
        v-model="form.name"
        :disabled="show == 1 ? true : false"
        @blur="
          () => {
            $refs.name.onFieldBlur();
          }
        "
      />
    </a-form-model-item>
    <a-form-model-item label="账号类型" prop="type">
      <a-select
              v-model="form.type"
              placeholder="请选择账号类型"
              @change="handleChangeType"
              :disabled="show == 1 ? true : false"
      >
        <a-select-option
                :value="item.id"
                v-for="(item, index) in typeList"
                :key="index"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="所属公司" prop="comp">
      <a-select
              v-model="form.compId"
              placeholder="请选择公司"
              @change="compChange"
              :disabled="show == 1 ? true : false"
      >
        <a-select-option
                :value="item.id"
                v-for="(item, index) in compList"
                :key="index"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item ref="phone" label="联系方式" prop="phone">
      <a-input
        placeholder="请输入联系方式"
        :maxLength="11"
        v-model="form.phone"
        :disabled="show == 1 ? true : false"
        @blur="
          () => {
            $refs.phone.onFieldBlur();
          }
        "
      />
    </a-form-model-item>

    <a-form-model-item ref="mail" label="邮箱" prop="mail">
      <a-input
              placeholder="请输入邮箱"
              :maxLength="36"
              v-model="form.mail"
              :disabled="show == 1 ? true : false"
              @blur="
          () => {
            $refs.mail.onFieldBlur();
          }
        "
      />
    </a-form-model-item>

    <a-form-model-item ref="account" label="登录账号" prop="account">
      <a-input
        placeholder="请输入登录账号"
        v-model="form.account"
        :disabled="show == 1 ? true : false"
        @blur="
          () => {
            $refs.account.onFieldBlur();
          }
        "
      />
    </a-form-model-item>

    <a-form-model-item
      :wrapper-col="{ span: 8, offset: 8 }"
      style="text-align: center;"
    >
      <a-button type="primary" @click="onSubmit" v-if="!id && !show">
        立即创建
      </a-button>
      <a-button type="primary" @click="onSubmit" v-if="id && !show">
        立即修改
      </a-button>
      <a-button style="margin-left: 10px;" @click="resetForm">
        取消
      </a-button>
      <!--      <a-button style="margin-left: 10px;" @click="resetForm">-->
      <!--        返回-->
      <!--      </a-button>-->
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { getRoleList } from "@/api/permission/role/index";
import { createUser, showUser, editUser } from "@/api/permission/user/index";

import { getAreaTree } from '@/api/area/index'
import { compAreaList } from '@/api/comp/comp'

// import { delete } from 'vue/types/umd';
export default {
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 8 },
      other: "",
      form: {
        name: "",
        type: undefined,
        phone: "",
        mail: "",
        areaId: undefined,
        compId: undefined,
        account: undefined
      },


      areaIds: [0,0,0],
      optionAreas: [
        {
          value: '1',
          label: '北京市'
        }
      ],
      showSearch: {
        filter: (inputValue, path) => {
          return path.some(option => {
                    // label搜索
                    return fullText(inputValue, option.label);
                  }
          )
        },
        matchInputWidth: true
      },

      compList:[],

      id: 0,
      show: 0,
      typeList: [
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        mail: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        org: [{ required: true, message: "请选择所属组织", trigger: "change" }],
        role: [{ required: true, message: "请选择角色", trigger: "change" }],
        account: [
          { required: true, message: "请输入登录账号", trigger: "blur" }
        ]
      }
    };
  },
  created() {

    // 获取当前账号信息
    this.areaId = 0

    this.getAccountTypeList()
    // 获取区划列表
    this.getAreaTree()

    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      showUser({
        accountId: this.id
      }).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.form.name = res.data.name;
          this.form.phone = res.data.phone;
          this.form.mail = res.data.mail;
          this.form.areaId = res.data.areaId;
          this.form.type = res.data.type;
          this.form.account = res.data.account;
          this.form.compId = res.data.compId;

          this.getAreaIds();
          this.getComp(this.form.areaId);
        }
      });
    }
    if (this.$route.query.show) {
      this.show = this.$route.query.show;
    }
  },
  methods: {
    getAreaIds () {
      var mfind = false;
      if(this.optionAreas != null && this.optionAreas.length > 0)
      {
        for(let i=0;i<this.optionAreas.length;i++)
        {
          if(this.optionAreas[i].value == this.form.areaId)
          {
            this.areaIds = [this.optionAreas[i].value,this.optionAreas[i].value]
            mfind = true;
            break;
          }
          else if(this.optionAreas[i].children!=null && this.optionAreas[i].children.length > 0)
          {
            for(let j=0;j<this.optionAreas[i].children.length;j++)
            {
              if(this.optionAreas[i].children[j].value == this.form.areaId)
              {
                this.areaIds = [this.optionAreas[i].value,this.optionAreas[i].children[j].value,this.optionAreas[i].children[j].value]

                mfind = true;
                break;
              }
              else  if(this.optionAreas[i].children[j].children!=null && this.optionAreas[i].children[j].children.length > 0)
              {
                for(let k=0;k<this.optionAreas[i].children[j].children.length;k++) {
                  if (this.optionAreas[i].children[j].children[k].value == this.form.areaId) {
                    this.areaIds = [this.optionAreas[i].value, this.optionAreas[i].children[j].value, this.optionAreas[i].children[j].children[k].value]

                    mfind = true;
                    break;
                  }
                }
              }
              if(mfind)
                break;

            }
            if(mfind)
              break;
          }
        }
      }


    },


    compChange (value) {
      this.form.compId = value
    },
    getComp (value) {
      compAreaList({
        page:1,
        size:100,
        areaId: value
      }).then(res => {
        this.compList = res.data.list
      });
    },

    areaChange (value) {
      this.form.areaId = value[value.length - 1]
      this.getComp(this.form.areaId);
    },
    getAreaTree () {
      getAreaTree({areaId:this.areaId}).then(response => {
        this.optionAreas = response.data
        this.getAreaIds();
      })
    },


    handleChangeType(value) {
      this.form.type = value;
    },
    getAccountTypeList () {
      getRoleList({page:1,size:100}).then(response => {
        this.typeList = response.data.list
      })
    },

    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (this.form.phone && !/^1[3456789]\d{9}$/.test(this.form.phone)) {
          this.$message.error("请输入正确的手机号");
          return;
        }
        if (valid) {
          if (this.id) {
            this.updateUser();
          } else {
            this.addUser();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addUser() {
      let _this = this;

      createUser({
        name: _this.form.name,
        type: _this.form.type,
        level: _this.form.type,
        phone: _this.form.phone,
        mail: _this.form.mail,
        areaId: _this.form.areaId,
        compId: _this.form.compId,
        account: _this.form.account,
        status: 0
      }).then(res => {
        console.log(res);
        if (res.code == 0) {
          _this.$message.success("新增成功", function() {
            _this.$router.push({ path: "/index/auth/userlist" });
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    updateUser() {
      let _this = this;
      let data = {
        id: _this.id,
        name: _this.form.name,
        type: _this.form.type,
        level: _this.form.type,
        phone: _this.form.phone,
        mail: _this.form.mail,
        areaId: _this.form.areaId,
        compId: _this.form.compId,
        account: _this.form.account,
      };

      editUser(data).then(res => {
        console.log(res);
        if (res.code == 0) {
          _this.$message.success("编辑成功", function() {
            _this.$router.push({ path: "/index/auth/userlist" });
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.$router.push({ path: "/index/auth/userlist" });
    }
  }
};
</script>

<style scoped>
.password-ok {
  position: absolute;
  top: -10px;
  left: -80px;
  color: red;
}
</style>
